module.exports = __webpack_public_path__ + "static/media/6-iron.e549dc20.png";